import { Decimal } from 'decimal.js';
import { SuperJSON, type SuperJSONResult } from 'superjson';

export type { SuperJSONResult } from 'superjson';

SuperJSON.registerCustom<Decimal, string>(
  {
    isApplicable: (v): v is Decimal => Decimal.isDecimal(v),
    serialize: (v) => v.toJSON(),
    deserialize: (v) => new Decimal(v),
  },
  'decimal.js',
);

SuperJSON.registerCustom<Buffer, number[]>(
  {
    isApplicable: (v): v is Buffer => v instanceof Buffer,
    serialize: (v) => [...v],
    deserialize: (v) => Buffer.from(v),
  },
  'buffer',
);

export function deserializeSuperjson<T>(data: SuperJSONResult): T {
  return SuperJSON.deserialize<T>(data);
}

export function serializeSuperjson<T>(data: T): SuperJSONResult {
  return SuperJSON.serialize(data);
}

/**
 * Check if data looks like a SuperJSON result.
 */
export function isSuperJSONResult(data: unknown): data is SuperJSONResult {
  return typeof data === 'object' && data !== null && 'json' in data;
}
